import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_SMS = createActionTypes('FETCH_SMS');
export const GET_SMS = createActionTypes('GET_SMS');
export const CREATE_SMS = createActionTypes('CREATE_SMS');
export const UPDATE_SMS = createActionTypes('UPDATE_SMS');
export const DELETE_SMS = createActionTypes('DELETE_SMS');
